// scroll bar
import 'simplebar/src/simplebar.css';
import './index.css';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PublicClientApplication, EventType, LogLevel, InteractionType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
//
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import App from './App';
import reportWebVitals from './reportWebVitals';
import Auth from './components/Auth';
import LoadingPage from './pages/Loading';
import ThemeConfig from './theme';

// Recoil
// ----------------------------------------------------------------------
import axios from 'axios';

// const axios = ax.create({
//   baseURL: '/api',
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'f85c2c34-e8ee-4094-a589-031a6b0bbf2c',
    authority: 'https://login.microsoftonline.com/d24a06ec-29d5-471e-b593-b47d69aac939',
    redirectUri: '/',
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.log('error:', message);
            return;
          case LogLevel.Info:
            // console.log('info:', message);
            return;
          case LogLevel.Verbose:
            // console.log('verbose:', message);
            return;
          case LogLevel.Warning:
            // console.log('warn:', message);
            return;
          default:
            return;
        }
      }
    },
    windowHashTimeout: 9000, // Applies just to popup calls - In milliseconds
    iframeHashTimeout: 9000, // Applies just to silent calls - In milliseconds
    loadFrameTimeout: 9000 // Applies to both silent and popup calls - In milliseconds
  }
});
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

axios.defaults.baseURL = '/api';
axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/json';

axios.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('v');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const account = msalInstance.getActiveAccount();

    if (error.response?.status === 401 && account) {
      // console.log('Refreshing token...');
      const response = await msalInstance.acquireTokenSilent({
        account: account
      });
      localStorage.setItem('v', response.idToken);
      // console.log('Token refreshed.');
      // console.log('Retrying request...');
      return axios.request(error.config);
    }

    console.error('Intercepted Error: ', error);
    return Promise.reject(error);
  }
);

export const queryClient = new QueryClient();

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{
        scopes: ['openid', 'profile']
      }}
      errorComponent={() => <div>error</div>}
      loadingComponent={() => <LoadingPage loading={true} />}
    >
      <ThemeConfig>
        <Auth>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <HelmetProvider>
              <BrowserRouter>
                <RecoilRoot>
                  <App />
                </RecoilRoot>
              </BrowserRouter>
            </HelmetProvider>
          </QueryClientProvider>
        </Auth>
      </ThemeConfig>
    </MsalAuthenticationTemplate>
  </MsalProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
